import { vendorDetails } from "../vendor/actions";
import {
  VENDOR_DETAILS_FAIL,
  VENDOR_DETAILS_REQUEST,
} from "../vendor/actionType";
import axios from "./utils/axios";

const fetchVendorView = (vendor_id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: VENDOR_DETAILS_REQUEST });
      const {
        login: { userInfo },
      } = getState();
      const config = {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };
      const { data } = await axios.get(`api/vendor/${vendor_id}/`, config);
      dispatch(vendorDetails(data));
    } catch (error) {
      dispatch({
        type: VENDOR_DETAILS_FAIL,
        payload:
          error.response && error.response.data.details
            ? error.response.data.details
            : error.message,
      });
    }
  };
};
export default fetchVendorView;
